module.exports = __webpack_public_path__ + "img/Jump Casting84.47142123.jpg";